import styled from "styled-components";
import { errorColor } from "../../../../config/constants";
import { inputCheckboxIndex } from "../../../../config/zIndex";

export const TreatmentDiv = styled.div`
  width: 100%;
  max-width: 860px;
  padding: 15px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const TitleTextDiv = styled.div`
  display: flex;
  justify-content: flex-start;
`;
export const TreatmentText = styled.p`
  margin: 20px 0;
  max-width: 760px;
  color: #808080;
  font-size: 12px;
`;
export const HospitalNameSpan = styled.span`
  font-weight: bold;
`;
export const TreatmentInputDiv = styled.div`
  display: flex;
  align-items: center;
`;
export const Label = styled.label`
  margin-right: 15px;
  font-size: 14px;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : "normal")};
`;
export const InputCheckboxDiv = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  border: ${({ error }) => error && `1px solid ${errorColor}`};
  border-radius: 3px;
`;
export const InputCheckbox = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  opacity: 0;
  position: absolute;
  z-index: ${inputCheckboxIndex};
`;
export const VerifyCheckboxImg = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
`;
